import React from 'react';

import { Sheet } from '@pkg/components';

import { NftFiltersSecondary } from '../NftFiltersSecondary/NftFiltersSecondary.tsx';

export interface NftFiltersMobileSheetProps {
    onClose: () => void;
}

export function NftFiltersMobileSheet({ onClose }: NftFiltersMobileSheetProps) {
    return (
        <Sheet onClose={onClose}>
            <Sheet.Header largeTitle title="NFT Filters" onClose={onClose} />

            <Sheet.Main>
                <Sheet.Layout>
                    <Sheet.Layout.Columns stretch>
                        <Sheet.Layout.Columns.Primary padded scrollable>
                            <NftFiltersSecondary />
                        </Sheet.Layout.Columns.Primary>
                    </Sheet.Layout.Columns>
                </Sheet.Layout>
            </Sheet.Main>
        </Sheet>
    );
}
